import React, { useState } from 'react';
// import Header from "../../components/shared/Header";

import BookADemoForm from '../../components/BookADemo/BookADemoForm';
import AppNavbar from '../../components/Home/Navbar';
import Footer from '../../components/Home/Footer';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { axiosPublic } from '../../api/axios';
import { toast } from 'react-toastify';

const ScheduleDemo = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<any>(false);

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      phone: '',
      companyName: '',
      timeSlot: '',
    },
    onSubmit: async (v) => {
      setLoading(true);
      await axiosPublic
        .post('/demos', {
          name: v.name,
          email: v.email,
          phone: v.phone,
          companyName: v.companyName,
          timeSlot: v.timeSlot,
        })
        .then(() => {
          setLoading(false);
          toast.success(
            `We have received your request. We'll get back to you shortly.`
          );
          navigate('/');
        })
        .catch((err) => {
          setLoading(false);
          toast.error(`${err.response?.data?.message}`);
        });
    },
  });
  return (
    <>
      <AppNavbar />
      <section className="min-h-screen flex flex-col bg-gray-100">
      <div className="flex-grow flex items-center justify-center py-16 px-4">
        <div className="w-full max-w-3xl bg-white shadow-xl rounded-2xl p-10">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-center text-gray-800 mb-2">
            Schedule a Demo
          </h2>
          <p className="text-center text-gray-600 mb-8">
            Get in touch and we’ll provide a solution tailored to your exact requirements.
          </p>
          <form onSubmit={formik.handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="name" className="block font-medium text-gray-700 mb-1">Name</label>
              <input
                id="name"
                type="text"
                value={formik.values.name}
                onChange={formik.handleChange}
                required
                className="w-full h-12 px-4 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-yellow-400 focus:outline-none"
                placeholder="Enter your name"
              />
            </div>

            <div>
              <label htmlFor="phone" className="block font-medium text-gray-700 mb-1">Phone Number</label>
              <input
                id="phone"
                type="tel"
                value={formik.values.phone}
                onChange={formik.handleChange}
                required
                className="w-full h-12 px-4 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-yellow-400 focus:outline-none"
                placeholder="Enter your phone number"
              />
            </div>

            <div>
              <label htmlFor="email" className="block font-medium text-gray-700 mb-1">Email</label>
              <input
                id="email"
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                required
                className="w-full h-12 px-4 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-yellow-400 focus:outline-none"
                placeholder="Enter your email"
              />
            </div>

            <div>
              <label htmlFor="companyName" className="block font-medium text-gray-700 mb-1">Company Name</label>
              <input
                id="companyName"
                type="text"
                value={formik.values.companyName}
                onChange={formik.handleChange}
                required
                className="w-full h-12 px-4 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-yellow-400 focus:outline-none"
                placeholder="Enter your company name"
              />
            </div>

            <div>
              <label htmlFor="timeSlot" className="block font-medium text-gray-700 mb-1">Time Slot</label>
              <input
                id="timeSlot"
                type="datetime-local"
                value={formik.values.timeSlot}
                onChange={formik.handleChange}
                required
                className="w-full h-12 px-4 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-yellow-400 focus:outline-none"
              />
            </div>

            <div>
              <button
                type="submit"
                className="w-full h-12 bg-yellow-400 hover:bg-yellow-500 transition-all duration-200 text-white font-semibold rounded-md shadow-md"
              >
                Book a Demo
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </section>

    </>
  );
};

export default ScheduleDemo;
